// export const API_URI = 'https://strapi-vrf6.onrender.com';

export const API_URI = 'https://strapi-17v0.onrender.com';
